import {
    BLOCKED,
    CONNECT_ERROR,
    EXPIRED_DOCUMENT,
    LOW_QUALITY,
    NON_EXCLUSIVE,
    WRONG_FACE_MATCH,
    WRONG_PERMISSIONS,
} from 'constants/video/status';

export const CUSTOM_MODAL_ERRORS = [
    NON_EXCLUSIVE,
    BLOCKED,
    LOW_QUALITY,
    CONNECT_ERROR,
    EXPIRED_DOCUMENT,
    WRONG_FACE_MATCH,
    WRONG_PERMISSIONS,
];
